<div *ngFor="let comment of comments">
  <a [routerLink]="['/courses/view',comment.form_data_id]">
    <small>{{comment.created_at | date:'short'}} Uhr {{comment.created_by?.name}}:</small></a>
  <p [class]="paragraphClass || 'lead'">{{comment.comment}}</p>
</div>
